import React from 'react';
import List from "./List";

export default function Archived() {
  return (
    <List isActual={false}/>
  )
}
